<template>
  <div id="el-one" class="el-card" style="display: flex; justify-content: center;align-items: center;
      width: 220px;height: 210px;border: 1px solid gainsboro;" @click="goToDeviceManagement(10)">
    <div class="DSFZ"><el-button id="ds-button"></el-button></div>
    <span style="font-size: 15px;position: absolute;top: 180px;color: green">{{"这是一个测试账号"}}</span>

  </div>
</template>

<script>
import axios from "axios";
import index from "vuex";

export default {
  name: "UserHome",
  computed: {
    index() {
      return index
    }
  },
  data(){
    return{
      company_id: [],
      company_names:[],
    }
  },
  created() {
    this.fetchCompanyName(); // 在组件挂载后调用异步请求函数
  },
  methods: {
    // 从后端获取企业id 和 企业名称
    fetchCompanyName() {
      // 发送异步请求获取后端数据
      axios.get('/otherApi/manager/getallcompany/')
        .then(res => {
          console.log(res)
          // 从返回的数据中获取公司名称和ID，并保存到组件的数据中
          this.company_names = res.data.data.map(company => company.company_name);
          this.company_ids = res.data.data.map(company => company.company_id);
        })
        .catch(error => {
          console.error('Error fetching company name:', error);
        });
    },
    // 根据企业id 去查到 企业id相关的设备表面参数
    goToDeviceManagement(index) {
      const company_id = this.company_ids[index];
      console.log('company_id =======' + company_id)
      this.$router.push({
        path:'/menu/testCard', // 路径
        query:{ company_id : company_id }, //查询参数
      })
      // 发送异步请求获取后端数据
      axios.get('/otherApi/manager/getallcompanysensor/',{
        params:{
          company_id : company_id,
        }
      }).then(res => {
        console.log(res)
        if (this.$route.path !== '/menu/testCard') {
          this.$router.push({path:'/menu/testCard',query:res.data.data});
        }
      })
    },
  }
}
</script>

<style scoped>
#el-one{
  position: absolute;
  top: 150px;
  left: 260px;
}
.DSFZ{
  background-image: url("../assets/img/img_2.png");
  background-size: 180px;
  width: 200px;
  height: 200px;
  background-repeat: no-repeat;
  position: absolute;
  top: 0px;
  left: 20px;
}
#ds-button{
  width: 80px;
  height: 80px;
  opacity: 0;
  margin-left: -8px;
  margin-top: -5px;
}
</style>



// WEBPACK FOOTER //
// src/components/TestHome.vue